import { render } from "./CallerIdsDialog.vue?vue&type=template&id=02b248d2&scoped=true"
import script from "./CallerIdsDialog.vue?vue&type=script&lang=js"
export * from "./CallerIdsDialog.vue?vue&type=script&lang=js"

import "./CallerIdsDialog.vue?vue&type=style&index=0&id=02b248d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b248d2"]])

export default __exports__